import { useLocation, useNavigate } from "react-router-dom";
import useAuthentication from "../../../hooks/useAuthentication";
import { useForm } from "react-hook-form";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import { getAllBodySystem, saveMasterData } from "./services";
import { useEffect } from "react";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const pageTitle = "HPI ";
function AddOrEditHPI() {
  const navigate = useNavigate();
  const { user } = useAuthentication();
  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });
  const { data: rosComponent } = useQuery([], getAllBodySystem);
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };
  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.data?.errorMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    save([
      {
        bodySystemId: value?.bodysystem?.bodySystemId as number,
        rosCode: value?.rosCode,
        rosName: value?.rosName,
        rosId: (data?.rosId as number) ?? null,
        rosCreatedByDate: "",
        rosCreatedById: Number(user?.userId),
        clinicId: Number(user?.clinicId),
        status: value?.rosStatus,
      },
    ]);
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  useEffect(() => {
    if (data) {
      reset({
        rosCode: data.rosCode,
        rosName: data?.rosName,
        bodysystem: {
          bodySystemName: data?.bodySystemName,
          bodySystemId: data?.bodySystemId,
        },
        rosStatus: data?.rosStatus ? 1 : 0,
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="rosCode"
              element="input"
              fieldProps={{ label: "Enter ros code " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="rosName"
              element="input"
              fieldProps={{ label: "Enter Ros name " }}
              rules={{ required: "Name is required" }}
            />
            <CustomFormField
              control={control}
              name="bodysystem"
              element="autocomplete"
              options={rosComponent?.response || []}
              autocompleteProps={{
                getOptionLabel: (option) => option.bodySystemName,
                isOptionEqualToValue: (option, value) =>
                  option.bodySystemId == value.bodySystemId,
              }}
              fieldProps={{ label: "Enter body system name" }}
              rules={{ required: "body system required" }}
            />
            <CustomFormField
              control={control}
              name="rosStatus"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Status is required" }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditHPI;
